import request from '@/utils/request'


export function exportData(data) {
  return request({
    url: 'CheckHeartLung/exportData',
    method: 'post',
    data
  })
}

export function getPageList(data) {
  return request({
    url: 'CheckHeartLung/getPageList',
    method: 'post',
    data
  })
}
